import {
	pendingColor,
	activeColor,
	backgroundColor,
	hexToRgb,
	dark_blue,
	cardBackground,
	grayColorShade_1,
	whiteColor,
	dangerColor,
	primaryColor,
	blackColor,
} from 'assets/jss/material-dashboard-pro-react';
import VIEW_DATA from 'assets/img/view-data.svg';
import VIEW_DATA_HOVER from 'assets/img/view-data-hover.svg';
import REFRESH_ICON from 'assets/img/refresh-status.svg';
import REFRESH_ICON_HOVER from 'assets/img/refresh-status-hover.svg';
import REFRESH_ICON_DISABLED from 'assets/img/refresh-status-disabled.svg';
import PDF_ACTIVE from 'assets/img/pdf.svg';
import PDF_HOVER from 'assets/img/pdf-active.svg';
import PDF_DISABLED from 'assets/img/pdf-disabled.svg';

const statusButton = {
	color: `${whiteColor} !important`,
	borderRadius: '5px',
	padding: '5px',
	minWidth: '80px',
	textAlign: 'center',
	marginBottom: '0px',
	whiteSpace: 'pre-wrap',
};
const paymentRequestStatusBOMStyle = (theme) => ({
	wrapper: {
		width: '100%',
	},
	amountCell: {
		textAlign: 'right',
	},
	actionCell: {
		display: 'flex',
		width: '80%',
		justifyContent: 'space-between',
	},
	Pending: {
		backgroundColor: `${pendingColor} !important`,
		...statusButton,
	},
	Approved: {
		backgroundColor: `${activeColor} !important`,
		...statusButton,
	},
	Rejected: {
		backgroundColor: `${dangerColor[0]} !important`,
		...statusButton,
	},
	Expired: {
		backgroundColor: `${grayColorShade_1} !important`,
		...statusButton,
	},
	Unreconciled: {
		...statusButton,
		backgroundColor: `${grayColorShade_1} !important`,
	},
	billNumbers: {
		display: 'flex',
		alignItems: 'center',
	},
	billToolTip: {
		marginLeft: '10px',
		color: `${whiteColor} !important`,
		fontSize: theme.fontSize(14),
	},
	billToolTipIcon: {
		marginLeft: '10px',
		fontSize: theme.fontSize(16),
		fontWeight: 'bold',
		cursor: 'pointer',
		color: `${primaryColor[0]}`,
	},
	billNumberList: {
		padding: '10px',
		display: 'flex',
		flexDirection: 'column',
	},
	status: {
		cursor: 'pointer',
		'&:hover': {
			color: `${primaryColor[0]} !important`,
		},
	},
	filtersWrapper: {
		display: 'flex',
	},
	alternativeSelectWrapper: {
		marginRight: '50px',
		flex: '1 1 0',
	},
	billPeriodWrapper: {
		background: whiteColor,
		position: 'absolute',
		zIndex: '999',
		width: '100%',
		padding: '15px',
		'& .rdt': {
			top: '70px !important',
		},
	},
	summaryWrapper: {},
	trasactionWrapper: {
		padding: '20px',
		borderBottom: `2px solid ${backgroundColor}`,
	},
	dateStatus: {
		display: 'flex',
		justifyContent: 'space-between',
		padding: ' 20px',
		paddingRight: '60px',
		borderBottom: `2px solid ${backgroundColor}`,
	},
	actionButton: {
		cursor: 'pointer',
		'&:focus': {
			border: `2px solid ${primaryColor[0]}`,
		},
	},
	refresh: {
		width: '30px',
		height: '25px',
		position: 'relative',
		overflow: 'hidden',
		'&:before': {
			content: `url(
				${REFRESH_ICON})`,
			position: 'absolute',
			top: '3px',
			left: 0,
			width: '100%',
			height: '100%',
			transition: 'opacity 0.3s ease-in-out,',
		},
		'&:hover': {
			'&:before': {
				content: `url(
					${REFRESH_ICON_HOVER})`,
			},
		},
	},
	refreshDisabled: {
		width: '30px',
		height: '25px',
		position: 'relative',
		cursor: 'not-allowed',
		overflow: 'hidden',
		'&:before': {
			content: `url(
				${REFRESH_ICON_DISABLED})`,
			position: 'absolute',
			top: '3px',
			left: 0,
			width: '100%',
			height: '100%',
			transition: 'opacity 0.3s ease-in-out,',
		},
	},
	viewPDFDisabled: {
		width: '30px',
		height: '25px',
		position: 'relative',
		cursor: 'not-allowed',
		overflow: 'hidden',
		'&:before': {
			content: `url(
				${PDF_DISABLED})`,
			position: 'absolute',
			top: '3px',
			left: 0,
			width: '100%',
			height: '100%',
			transition: 'opacity 0.3s ease-in-out,',
		},
	},
	viewPDF: {
		width: '30px',
		height: '25px',
		position: 'relative',
		overflow: 'hidden',
		'&:before': {
			content: `url(
				${PDF_ACTIVE})`,
			position: 'absolute',
			top: '3px',
			left: 0,
			width: '100%',
			height: '100%',
			transition: 'opacity 0.3s ease-in-out,',
		},
		'&:hover': {
			'&:before': {
				content: `url(
					${PDF_HOVER})`,
			},
		},
	},
	viewData: {
		width: '30px',
		height: '25px',
		position: 'relative',
		overflow: 'hidden',
		'&:before': {
			content: `url(
				${VIEW_DATA})`,
			position: 'absolute',
			top: '2px',
			left: 0,
			width: '100%',
			height: '100%',
			transition: 'opacity 0.3s ease-in-out,',
		},
		'&:hover': {
			'&:before': {
				content: `url(
					${VIEW_DATA_HOVER})`,
			},
		},
	},
	loadingWrapper: {
		height: '100px',
		display: 'flex',
		justifyContent: 'center',
	},
	actionHeader: {
		position: 'absolute',
		left: '26%',
		top: '40%',
	},
	statusWrapper: {
		display: 'flex',
		alignItems: 'center',
	},
	errorCodeTip: {
		marginLeft: '5px',
		cursor: 'pointer',
		color: blackColor,
	},
	toolTipColor: {
		color: `${whiteColor} !important`,
	},
});

export default paymentRequestStatusBOMStyle;
